<template>
    <SecHeader :props-function="{ 'onLogout': onLogout }" :props-option="['theme', 'locales', 'profile']"
        :props-store="{ app: appStore, user: userStore, action: actionStore }" :props-user-title="userType" />
</template>

<style scoped></style>

<script lang="ts" setup>
import { computed } from 'vue';
import { useAppStore, useUserStore, useActionStore } from '@coreStores/index';
import { SecHeader } from '@app/base-package';
import mxLogout from '@mixins/mxLogout';

/* ------ Declaration ------ */
const appStore = useAppStore();
const userStore = useUserStore();
const actionStore = useActionStore();
const { onLogout } = mxLogout();

/* ------ Computed ------ */
const userType = computed((): string => {
    switch (userStore.getType()) {
        case 'adm':
            return 'it_admin';
        case 'stg':
            return 'group_admin';
        case 'afl':
            return 'affiliate_admin';
        default:
            return '';
    }
});
</script>